import { BaseComponent } from "../../BaseComponent.js";
import { defineElement } from "../../../decorators/defineElement.js";
import { prop } from "../../../decorators/prop/index.js";
import { css, html } from "lit";
import "../PaginationSize/index.js";
import "../Option/index.js";
import "../IconButton/index.js";
import { preventDefault } from "../../../decorators/preventDefault.js";
import { testingAttr } from "../../../directives/testingAttr.js";
import { TestingAttrs } from "./paginationSelector.selectors.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
let DsfPaginationSelector = class extends BaseComponent {
  constructor() {
    super(...arguments);
    this.dsf_page = 1;
    this.dsf_pages = 1;
    this.dsf_text = "";
    this.dsf_accessibility_label = "";
    this.dsf_title_previous = "";
    this.dsf_title_next = "";
    this.dsf_flip = true;
    this.dsf_shift = true;
    this.dsf_hide = false;
    this.dsf_open_on_focus = false;
  }
  handleChange(e) {
    this.onChange(e.detail);
  }
  onChange(newPage) {
    this.dsf_page = newPage;
    this.emit({ name: "change", payload: newPage });
  }
  render() {
    const options = Array(this.dsf_pages).fill(void 0).map((_, idx) => {
      const page = idx + 1;
      return html`<dsf-option value=${page}>${page}</dsf-option>`;
    });
    return html`
      <div class="flex flex-row items-center" data-skeleton>
        <dsf-pagination-size
          value=${this.dsf_page}
          dsf_text=${`${this.dsf_pages} ${this.dsf_text}`}
          dsf_accessibility_label=${this.dsf_accessibility_label}
          ?dsf_flip=${this.dsf_flip}
          ?dsf_shift=${this.dsf_shift}
          ?dsf_hide=${this.dsf_hide}
          ?dsf_open_on_focus=${this.dsf_open_on_focus}
          @change=${this.handleChange}
        >
          ${options}
        </dsf-pagination-size>
        <dsf-icon-button
          dsf_size="small"
          dsf_icon="ChevronLeft"
          dsf_title=${this.dsf_title_previous}
          ?disabled=${this.dsf_page <= 1}
          @click=${() => this.onChange(this.dsf_page - 1)}
          ${testingAttr(TestingAttrs.prevPageButton)}
        ></dsf-icon-button>
        <dsf-icon-button
          dsf_size="small"
          dsf_icon="ChevronRight"
          dsf_title=${this.dsf_title_next}
          ?disabled=${this.dsf_page >= this.dsf_pages}
          @click=${() => this.onChange(this.dsf_page + 1)}
          ${testingAttr(TestingAttrs.nextPageButton)}
        ></dsf-icon-button>
      </div>
    `;
  }
};
DsfPaginationSelector.styles = [
  ...BaseComponent.styles,
  css`
      dsf-pagination-size::part(dropdown) {
        max-height: 260px;
      `
];
__decorateClass([
  prop({ type: Number })
], DsfPaginationSelector.prototype, "dsf_page", 2);
__decorateClass([
  prop({ type: Number })
], DsfPaginationSelector.prototype, "dsf_pages", 2);
__decorateClass([
  prop({ type: String })
], DsfPaginationSelector.prototype, "dsf_text", 2);
__decorateClass([
  prop({ type: String })
], DsfPaginationSelector.prototype, "dsf_accessibility_label", 2);
__decorateClass([
  prop({ type: String })
], DsfPaginationSelector.prototype, "dsf_title_previous", 2);
__decorateClass([
  prop({ type: String })
], DsfPaginationSelector.prototype, "dsf_title_next", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfPaginationSelector.prototype, "dsf_flip", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfPaginationSelector.prototype, "dsf_shift", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfPaginationSelector.prototype, "dsf_hide", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfPaginationSelector.prototype, "dsf_open_on_focus", 2);
__decorateClass([
  preventDefault
], DsfPaginationSelector.prototype, "handleChange", 1);
DsfPaginationSelector = __decorateClass([
  defineElement("dsf-pagination-selector")
], DsfPaginationSelector);
export {
  DsfPaginationSelector
};
